import axios from 'axios';

import { Label } from 'admin/labels/Label.types';
import { SearchRequest } from 'core/util/Search';

export const getLabels = async (tenantId: number | undefined, search?: SearchRequest): Promise<Label[]> => {
    const { data } = await axios.get<Label[]>(`/api/tenants/${tenantId}/labels`, { params: { search } });

    return data;
};

export const getLabel = async (tenantId: number, labelId: string): Promise<Label> => {
    const { data } = await axios.get<Label>(`/api/tenants/${tenantId}/labels/${labelId}`);

    return data;
};

export const saveLabel = async (tenantId: number, label: Label): Promise<Label> => {
    const { data } = await axios.post<Label>(`/api/tenants/${tenantId}/labels`, { ...label });

    return data;
};
